import React from "react";
import { DOC_CENTER } from "@/constants/testIds";

const WORKSPACE_PRODUCTS = [
  "RFQ™",
  "CommodityBid™",
  "Document Center™",
  "FreightIQ™",
  "Inspection™",
  "Live Shipment Tracking™",
  "SmartContainer™",
];

export default function Footer() {
  return (
    <footer data-testid={DOC_CENTER.footer.container} className="border-t border-[color:var(--dc-border)] bg-white">
      <div className="dc-container py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2">
            <span className="font-display text-[15px] font-extrabold tracking-tight text-ink-950">DeMaxtore</span>
            <p className="mt-3 max-w-sm text-[13.5px] leading-relaxed text-ink-600">
              The enterprise import operating system. A connected Workspace for every team building
              the next decade of global trade.
            </p>
          </div>

          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-500">Workspace</div>
            <ul className="mt-3 space-y-2 text-[13.5px] text-ink-700">
              {WORKSPACE_PRODUCTS.map((p) => (
                <li key={p}><a className="hover:text-ink-950 transition-colors" href="#workspace">{p}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-500">Document Center</div>
            <ul className="mt-3 space-y-2 text-[13.5px] text-ink-700">
              <li><a href="#why" className="hover:text-ink-950 transition-colors">Why Document Center</a></li>
              <li><a href="#workspace" className="hover:text-ink-950 transition-colors">Workspace integration</a></li>
              <li><a href="#faq" className="hover:text-ink-950 transition-colors">FAQ</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-[color:var(--dc-border)] pt-6 sm:flex-row sm:items-center">
          <span className="font-mono text-[11px] uppercase tracking-wider text-ink-500">
            © {new Date().getFullYear()} DeMaxtore · Document Center™
          </span>
          <span className="font-mono text-[11px] uppercase tracking-wider text-ink-500">
            Built for import operations
          </span>
        </div>
      </div>
    </footer>
  );
}
